<mat-dialog-content class="terms">
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
		class="terms__heading"
	>
		Terms of Service
	</epi-heading>
	<p class="terms__content m--italic m--bold">
		By purchasing this policy for your pet, you understand and agree to the following:
	</p>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsVetVisit"
			class="terms__content m--bold"
		>
			Vet Visit Requirements:
		</p>
		<p>
			It is required that your insured pet has a complete veterinarian (or "vet") exam, with medical notes
			from your vet within the past 12 months or during the 14-day waiting period in order for your pet's
			illness coverage to start.
			Since a full exam is required, taking your pet to a spay/neuter or vaccination clinic may not qualify.
			Please ensure that this exam is complete.
		</p>
	</section>
	<section
		class="terms__listgroup u-margin-top-small"
	>
		<p
			id="termsWaitingPeriods"
			class="terms__content m--bold"
		>
			Start date and waiting periods:
		</p>
		<ul
			class="terms__list"
			aria-labelledby="termsWaitingPeriods"
		>
			<li class="terms__list-item">
				Your policy begins on the start date shown on your declarations page.
			</li>
			<li class="terms__list-item">
				There is a 14-day waiting period for illnesses.
			</li>
			<li class="terms__list-item">
				Waiting periods/exclusion for orthopedic conditions vary by state. Please check your 
				<a
					qeBaseLink
					class="n--minimal"
					href="https://www.embracepetinsurance.com/coverage/embrace-terms"
					target="_blank"
				>Policy Terms and Conditions</a> 
				for details.
			</li>
		</ul>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsPreExisting"
			class="terms__content m--bold"
		>
			Pre-existing conditions are not covered.
		</p>
		<p>
			If your pet has any pre-existing conditions, those conditions are not covered by your policy.
			A pre-existing condition is anything that is diagnosed <span class="inline__style m--bold">OR</span> shows
			symptoms before the purchase of the policy,
			and through the end of the waiting periods. A condition can be considered pre-existing, even if no treatment
			was given at the time.
		</p>
	</section>
	<section class="terms_listgroup u-margin-top-small">
		<p
			id="termsRenewals"
			class="terms__content m--bold"
		>
			Renewals and Payment Terms
		</p>
		<p>
			Your policy will automatically renew annually.
		</p>
		<ul
			class="terms__list"
			aria-labelledby="termsRenewals"
		>
			<li class="terms__list-item">
				You have 60 days from the renewal date to submit claims from the prior term.
			</li>
			<li class="terms__list-item">
				You will receive a notification of renewal with your new premium amount prior to the start date on your
				new policy.
				You must notify Embrace if you do not wish to renew your policy.
			</li>
			<li class="terms__list-item">
				You agree to the &nbsp;<a
					qeBaseLink
					class="n--minimal"
					href="https://www.embracepetinsurance.com/payment-terms"
					target="_blank"
				>Embrace Payment Terms</a>
			</li>
		</ul>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsDigitalDocuments"
			class="terms__content m--bold"
		>
			Digital Documents
		</p>
		<p>
			You'll soon be receiving all of your policy documents and communications by email, including the policy
			terms and conditions. You're responsible for keeping your email and other contact information current.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsCustomerAccount"
			class="terms__content m--bold"
		>
			Customer Account
		</p>
		<p>
			You'll l be receiving an email on how to set up your customer account.
			<span class="inline__style m--bold">It's very important that you sign up as soon as possible.</span>
			Upon entering your customer account you'll be prompted to list all vet hospitals your pet has seen.
			This is also where you can review policy documents, file claims, view claims status and make changes to your
			policy.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsSupplementalCoverage"
			class="terms__content m--bold"
		>
			Supplemental Coverage
		</p>
		<p>
			If you removed Prescription/RX or Exam Fee coverage from one or more pets, these coverages cannot
			be added back on without a reset of the waiting periods.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsWellness"
			class="terms__content m--bold"
		>
			Wellness Rewards (if purchased)
		</p>
		<p>
			Wellness Rewards is a separate product and is <span class="inline__style m--bold">not insurance</span>.
			It is a budgeting plan that reimburses for preventative care.
			There is no waiting period or deducible and your funds are available on the policy start date.
			Your balance is to be paid off throughout the 12-month term.
			If you cancel your policy early and use more funds than you paid into the program, you'll be responsible for
			paying back the difference.
			Any remaining balance will not roll over to the next term. Please review the Wellness Certificate and
			Agreement that will be emailed to you.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsAccidentOnly"
			class="terms__content m--bold"
		>
			Accident Only Coverage (if purchased)
		</p>
		<p>
			This policy is for injuries due to unexpected accidents only. It does not provide coverage for any illness even 
			if the illness is related to an underlying condition of an accident. This policy does not cover orthopedic
			conditions.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p class="terms__content m--bold">
			I understand it is my responsibility to read the full
			&nbsp;<a
				qeBaseLink
				class="n--minimal"
				(click)="openEmbracePolicyModal($event)"
			>Embrace Policy Terms and Conditions</a>
			&nbsp;that will be sent to me and
			&nbsp;<a
				qeBaseLink
				class="n--minimal"
				(click)="openStateFraudModal($event)"
			>state fraud advisories</a>.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsFraudStatement"
			class="terms__content m--bold"
		>
			FRAUD STATEMENT
		</p>
		<p>
			Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or
			knowingly presents false information in an application for insurance is guilty of a crime and may
			be subject to fines and confinement in prison.
		</p>
	</section>
	<section class="terms__listgroup u-margin-top-small">
		<p
			id="termsVerify"
			class="terms__content m--bold"
		>
			You verify that the information shown on your application is true and complete.
		</p>
		<ul
			class="terms__list"
			aria-labelledby="termsVerify"
		>
			<li class="terms__list-item">
				You understand that non-disclosure or misrepresentation may render this contract null and void.
			</li>
			<li class="terms__list-item">
				You acknowledge that you are 18 years of age or older.
			</li>
			<li class="terms__list-item">
				You have selected the coverages you want.
			</li>
			<li class="terms__list-item">
				We do not collect health information or credit reports on consumers that have a Pet Health Insurance
				Policy.
			</li>
		</ul>
	</section>
	<section class="u-margin-top-small">
		<p class="terms__content">
			If you have any questions regarding these terms of service, please contact Embrace:
		</p>
		<div>
			<epi-infoline make-bold="key">
				<span slot="key">Phone</span>
				<span slot="value">(800) 511-9172</span>
			</epi-infoline>
		</div>
		<div>
			<epi-infoline make-bold="key">
				<span slot="key">Email</span>
				<span slot="value">hello@embracepetinsurance.com</span>
			</epi-infoline>
		</div>
		<div>
			<epi-infoline make-bold="key">
				<span slot="key">Mailing Address</span>
				<span slot="value">PO Box 22188 Beachwood, OH 44122-0188</span>
			</epi-infoline>
		</div>
	</section>
</mat-dialog-content>